import PatientInfoPanelContainer from './PatientInfoPanelContainer';

export default PatientInfoPanelContainer;
